import React from "react";

import { ArrowForward, ArrowBack, ChevronRight } from "components/Icons";

import "./style.scss";

const AnimatedArrow = ({ kind = "forward", move = "right" }) => (
  <div className="animated-arrow">
    {kind === "back" ? (
      <ArrowBack className={move} />
    ) : kind === "forward" ? (
      <ArrowForward className={move} />
    ) : (
      <ChevronRight className={move} />
    )}
  </div>
);

export default AnimatedArrow;
